export const IMG_PROMPT_MAX_LENGTH = 3000
export const IMG_PROMPT_HEIGHT = 200
